<template>
  <div class="module-wrap module-map-dadiji">
    <div :class="['img-wrap', {'all-img': isShow}]">
      <img :src="imgSrc"/>
      <p class="img-mask"></p>
    </div>
    <div class="show-btn">
      <a class="btn" v-if="isShow" @click="isShow=!isShow">
        收 起<i class="arrow top-arrow"></i>
      </a>
      <a @click="isShow=!isShow" class="btn" v-else>
        展开全部<i class="arrow down-arrow"></i>
      </a>
    </div>
    <p>* 图谱选取了部分章进行展示，不同教材版本之间各个章的学习顺序和年级分布有所不同</p>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'ModuleMapDadiji',
  data() {
    return {
      isShow: false,
      imgSrc: '',
      typeMap: {
        primary: '小学',
        junior: '中学',
        senior: '高中',
      },
    };
  },

  props: {
    isMobile: {
      type: Boolean,
      require: true,
    },
    type: {
      type: String,
      default: '',
    },
  },
  mounted() {
    this.imgSrc = require(`@/assets/img/dadiji/${this.type}.png`);
  },
  methods: {
    showImg() {
      this.isShow = true;
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.module-map-dadiji {
  width: 676px;
  margin: 48px auto 0 auto;
  .img-wrap {
    position: relative;
    height: 432px;
    overflow: hidden;
    img {
      max-width: 100%;
    }
    .img-mask{
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 88px;
      background: linear-gradient(360deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%);
    }
    &.all-img{
      height: auto;
      .img-mask{
        display: none;
      }
    }
  }
  .show-btn{
    padding: 12px 0;
    text-align: center;
    .btn{
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #00B1FF;
      line-height: 20px;
      border: none;
      background: none;
    }
  }
}
.arrow {
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-left: 8px;
  vertical-align: middle;
}
.top-arrow {
  border-top: 2px solid #00B1FF;
  border-left: 2px solid #00B1FF;
  transform: rotate(45deg);
}
// 向下箭头
.down-arrow {
  border-top: 2px solid #00B1FF;
  border-left: 2px solid #00B1FF;
  transform: rotate(225deg);
}
</style>
<style scoped>
  @media screen and (max-device-width: 1024px) {
  }

</style>
